import { render, staticRenderFns } from "./Latecomers.vue?vue&type=template&id=5da9da7b&scoped=true"
import script from "./Latecomers.vue?vue&type=script&lang=js"
export * from "./Latecomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da9da7b",
  null
  
)

export default component.exports